import { PermissionNameUnionType } from '@api';
import { PermittedItemType } from '@common';
import {
  faChartLine,
  faClipboard,
  faCogs,
  faFolderOpen,
  faGlobeEurope,
  faGuitar,
  faHouse,
  faIndustry,
  faMapMarkerAlt,
  faMusic,
  faPoll,
  faUser,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { LinkComponentProps } from '@tanstack/react-router';
import { CommonEndKey } from 'src/i18next';

export type NavigationLink = PermittedItemType<PermissionNameUnionType> & {
  icon: FontAwesomeIconProps['icon'];
  labelKey: CommonEndKey<'NAVIGATION'>;
  path: LinkComponentProps['to'];
  legacyPath: string;
  useLegacyAnchor: boolean;
};

export const navigationLinks: NavigationLink[] = [
  {
    icon: faHouse,
    labelKey: 'DASHBOARD',
    path: '/dashboard',
    legacyPath: '/',
    useLegacyAnchor: false,
    requiredPermissions: [],
  },
  {
    icon: faUser,
    labelKey: 'PERSONS',
    path: '/persons',
    legacyPath: '/addressbook/persons',
    useLegacyAnchor: false,
    requiredPermissions: [
      {
        permission: 'ADDRESSBOOK_PERSONS',
        action: 'READ',
      },
      {
        permission: 'ADDRESSBOOK_TOURREP_SCHEDULE',
        action: 'READ',
      },
    ],
  },
  {
    icon: faIndustry,
    labelKey: 'COMPANIES',
    path: '/companies',
    legacyPath: '/addressbook/companies',
    useLegacyAnchor: false,
    requiredPermissions: [
      {
        permission: 'ADDRESSBOOK_COMPANIES',
        action: 'READ',
      },
    ],
  },
  // {
  //   icon: faEnvelope,
  //   labelKey: 'MAILING_LISTS',
  //   path: '/mailinglists',
  //   legacyPath: '/addressbook/mailinglists',
  //   useLegacyAnchor: true,
  //   requiredPermissions: [
  //     {
  //       permission: 'ADDRESSBOOK_EMAILVERTEILER',
  //       action: 'READ',
  //     },
  //   ],
  // },
  {
    icon: faMusic,
    labelKey: 'ARTISTS',
    path: '/artists',
    legacyPath: '/artists',
    useLegacyAnchor: false,
    requiredPermissions: [
      {
        permission: 'ARTISTS_GENERAL',
        action: 'READ',
      },
    ],
  },
  {
    icon: faMapMarkerAlt,
    labelKey: 'VENUES',
    path: '/venues',
    legacyPath: '/addressbook/venues',
    useLegacyAnchor: false,
    requiredPermissions: [
      {
        permission: 'VENUES_GENERAL',
        action: 'READ',
      },
    ],
  },
  {
    icon: faGlobeEurope,
    labelKey: 'TOURING',
    path: '/projects/touring',
    legacyPath: '/projects/touring',
    useLegacyAnchor: true,
    requiredPermissions: [
      {
        permission: 'PROJECTS_TOURING',
        action: 'READ',
      },
      {
        permission: 'PROJECTS_TOURING_AS_TOURREP',
        action: 'READ',
      },
    ],
  },
  {
    icon: faGuitar,
    labelKey: 'FESTIVALS',
    path: '/projects/festivals',
    legacyPath: '/projects/festivals',
    useLegacyAnchor: true,
    requiredPermissions: [
      {
        permission: 'PROJECTS_FESTIVALS',
        action: 'READ',
      },
    ],
  },
  {
    icon: faPoll,
    labelKey: 'TICKET_SALES',
    path: '/projects/sales',
    legacyPath: '/projects/sales',
    useLegacyAnchor: true,
    requiredPermissions: [
      {
        permission: 'PROJECTS_TICKETSALES',
        action: 'READ',
      },
    ],
  },
  {
    icon: faFolderOpen,
    labelKey: 'LEGAL',
    path: '/documents',
    legacyPath: '/legal',
    useLegacyAnchor: false,
    requiredPermissions: [
      {
        permission: 'ORGANIZATION_DOCUMENTS',
        action: 'READ',
      },
    ],
  },
  {
    icon: faChartLine,
    labelKey: 'FINANCE',
    path: '/finance/overview',
    legacyPath: '/finance',
    useLegacyAnchor: false,
    requiredPermissions: [
      {
        permission: 'FINANCE',
        action: 'READ',
      },
    ],
  },
  {
    icon: faClipboard,
    labelKey: 'REPORTS',
    path: '/reports',
    legacyPath: '/reports',
    useLegacyAnchor: true,
    requiredPermissions: [
      {
        permission: 'REPORTS',
        action: 'READ',
      },
    ],
  },
  {
    icon: faCogs,
    labelKey: 'SYSTEM_SETTINGS',
    path: '/system',
    legacyPath: '/system',
    useLegacyAnchor: true,
    requiredPermissions: [
      {
        permission: 'ADMIN_GROUPS',
        action: 'READ',
      },
      {
        permission: 'ADMIN_USERS',
        action: 'READ',
      },
    ],
  },
];
